import { ActionDef } from "./ActionDef"

export const setAppScreenshotSavedDetails = (detailsArr) => {
    return{
        type:ActionDef.SET_APP_SCREENSHOT_SAVED_FLAG,
        payload:detailsArr
    }
}